export const BoxSVGStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  rowGap: '1rem',
  my: '2rem',
  height: '15rem',
};
